import { Field, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import type { NotificationPriorityEnum } from './NotificationPriorityEnum'
import type { NotificationChannelEnum } from './NotificationChannelEnum'
import type { MetadataType } from '../base'
import { Metadata } from '../base'
import type { NotificationTypeEnum } from './NotificationTypeEnum'
import { NotificationScope } from './NotificationScope'
import GraphQLJSON from 'graphql-type-json'

@ObjectType()
@InputType('NotificationInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class Notification extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String, required: true })
  title: string

  @Field(() => String)
  @Prop({ type: String })
  bodyPlain?: string

  @Field(() => String)
  @Prop({ type: String })
  bodyHtml?: string

  @Field(() => String)
  @Prop({ type: String })
  type?: NotificationTypeEnum

  @Field(() => String)
  @Prop({ type: String })
  priority?: NotificationPriorityEnum

  @Field(() => String)
  @Prop({ type: String })
  channel?: NotificationChannelEnum

  @Field(() => String)
  @Prop({ type: String })
  url?: string

  @Field(() => String)
  @Prop({ type: String })
  declare status?: string // unread, read, dismissed

  @Field(() => Boolean)
  @Prop({ type: Boolean, default: false })
  isSeen?: boolean

  @Field(() => Boolean)
  @Prop({ type: Boolean, default: false })
  isRead?: boolean

  @Field(() => Boolean)
  @Prop({ type: Boolean, default: false })
  isArchived?: boolean

  @Field(() => Boolean)
  @Prop({ type: Boolean, default: false })
  requiresAction?: boolean

  @Field(() => Date)
  @Prop({ type: Date })
  sentAt?: Date

  @Field(() => Date)
  @Prop({ type: Date })
  readAt?: Date

  @Field(() => Date)
  @Prop({ type: Date })
  expiresAt?: Date

  @Field(() => String)
  @Prop({ type: String })
  metadataString?: string

  @Field(() => GraphQLJSON)
  @Prop({ type: Metadata })
  metadata?: MetadataType

  @Field(() => NotificationScope)
  @Prop({ type: NotificationScope })
  scope?: NotificationScope
}
